<div class="dialog-content-min">
  <form [formGroup]="unlicensedUserForm">
    <div class="formgrid grid m-2">
      <div class="field col-12 md:col-6">
        <label for="firstname" class="label-spacing required-label">
          First Name<span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 100 chars) </span><span
            >*</span>
        </label>
        <textarea pInputTextarea class="form-control required-label" type="text" placeholder="Enter First Name" id="firstname"
          formControlName="firstname" required name="firstname"></textarea>
        <span class="errormessage"
          *ngIf="unlicensedUserForm.get('firstname').invalid && (unlicensedUserForm.get('firstname').dirty || unlicensedUserForm.get('firstname').touched)">
          {{getErrorMessage(unlicensedUserForm, validation_message, 'firstname')}}
        </span>
      </div>

      <div class="field col-12 md:col-6">
        <label for="lastname" class="label-spacing required-label">
          Last Name<span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 100 chars) </span><span>*</span>
        </label>
        <textarea pInputTextarea class="form-control" type="text" placeholder="Enter Last Name" id="lastname"
          formControlName="lastname" required name="lastname"></textarea>
        <span class="errormessage"
          *ngIf="unlicensedUserForm.get('lastname').invalid && (unlicensedUserForm.get('lastname').dirty || unlicensedUserForm.get('lastname').touched)">
          {{getErrorMessage(unlicensedUserForm, validation_message, 'lastname')}}
        </span>
      </div>
      <div class="field col-12">
        <label for="email" class="label-spacing required-label">
          Email<span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 100 chars) </span><span>*</span>
        </label>
        <textarea pInputTextarea class="form-control" type="text" placeholder="Enter Email" id="email"
          formControlName="email" required name="email"></textarea>
        <span class="errormessage"
          *ngIf="unlicensedUserForm.get('email').invalid && (unlicensedUserForm.get('email').dirty || unlicensedUserForm.get('email').touched)">
          {{getErrorMessage(unlicensedUserForm, validation_message, 'email')}}
        </span>
      </div>
      <div class="field col-12 md:col-6">
        <label *ngIf="!isEdit" for="productid" class="label-spacing required-label">Products <span>*</span></label>
        <label *ngIf="isEdit" for="productid">Product Name</label>
        <p-multiSelect *ngIf="!isEdit" [options]="filterproductdata" id="productid" formControlName="productid"
          placeholder="Select Product" optionLabel="productname" appendTo="body" [resetFilterOnHide]="true"
          (onChange)="onSelectProduct(unlicensedUserForm.get('productid').value)"
          [pTooltip]="getSelectedProductTooltip()" [filter]="true" tooltipPosition="top">
        </p-multiSelect>
        <span style="color:red; margin-top: 0px;"
          *ngIf="unlicensedUserForm.get('productid').invalid && (unlicensedUserForm.get('productid').touched || unlicensedUserForm.get('productid').dirty ) && !isEdit">
          {{getErrorMessage(unlicensedUserForm, validation_message, 'productid')}}
        </span>
        <input *ngIf="isEdit" class="form-control makedesable" type="text" placeholder="" id="productName"
          formControlName="productName" required name="productName" [disabled]="isEdit" />
      </div>

      <div class="field col-12 md:col-6">
        <label for="userType" class="label-spacing required-label"> User Type <span>*</span></label>
        <p-dropdown [options]="userType" id="userType" [filter]="true" appendTo="body" name="userType"
          optionLabel="labelname" optionValue="value" placeholder="Select User Type" [resetFilterOnHide]="true"
          formControlName="userType"></p-dropdown>
        <span style="color:red; margin-top: 0px;"
          *ngIf="unlicensedUserForm.get('userType').invalid && (unlicensedUserForm.get('userType').touched || unlicensedUserForm.get('userType').dirty )">
          {{getErrorMessage(unlicensedUserForm, validation_message, 'userType')}}
        </span>
      </div>
      <div *ngIf="isEdit" class="field col-12 md:col-6">
        <label for="activeFlag" class="label-spacing"> Active Flag </label>
        <p-dropdown [options]="activeFlag" id="activeFlag" [filter]="true" appendTo="body" name="activeFlag"
          optionLabel="labelname" optionValue="value" placeholder="Select Flag" formControlName="activeFlag"
          [disabled]="deleteFlag !== 'N'" [resetFilterOnHide]="true">
        </p-dropdown>
      </div>

    </div>
  </form>
</div>

<div class="custom-dialog-footer">
  <div class="mt-1"></div>
  <p-button class="m-1" label="Close" styleClass="customeclose"
    (click)="closemodal(unlicensedUserForm,this.ref,'Are you sure, you want to close?')"></p-button>
  <p-button class="m-1" *ngIf="!onlyView" label="{{saveTitle}}" styleClass="customesave" (click)="addUser()"></p-button>
  <div class="mt-1"></div>
</div>